import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { LenderAccountApi, LenderAccountOverview, LenderCardSummary } from '../tokens/lender-account.token';

/**
 * REST-only implementation of {@link LenderAccountApi}.
 *
 * Calls:
 *   GET  /services/embedded/api/business/lender/account
 *   POST /services/embedded/api/business/lender/account/cards  body: { formFactor }
 *
 * Rule 07 / Rule 10 — no mock fallback. Playwright specs intercept via `page.route()`.
 * Authority: ROLE_LENDER or ROLE_LENDER_RM (enforced server-side + roleGuard).
 */
@Injectable()
export class LenderAccountRestService implements LenderAccountApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/business/lender/account`;

  getOverview(): Observable<LenderAccountOverview> {
    return this.http.get<LenderAccountOverview>(this.base);
  }

  requestCard(formFactor: 'VIRTUAL' | 'PHYSICAL'): Observable<LenderCardSummary> {
    return this.http.post<LenderCardSummary>(`${this.base}/cards`, { formFactor });
  }
}
